export const modalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // maxHeight: "600px",
  overflow: "hidden",
  width: 400,
  bgcolor: "background.paper",
  border: "1px solid #000",
  borderRadius: "4px",
  boxShadow: 5,
  display: "flex",
  gap: 2,
  p: 2,
  flexDirection: "column",
};

export const modalStyleLog = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  overflow: "hidden",
  width: 500,
  maxHeight: 600,
  bgcolor: "background.paper",
  border: "1px solid #000",
  borderRadius: "4px",
  boxShadow: 5,
  display: "flex",
  gap: 2,
  p: 2,
  flexDirection: "row",
};

export const prepareAccountDataToUi = (response): any => {
  let data: any = [];
  let raw: any = null;
  raw = response.data.rows;
  var date: any = null;
  for (var i = 0, length = raw.length; i < length; i++) {
    date = new Date(raw[i].creationTime);
    if (date.getFullYear() === 1970) {
      raw[i].creationTime = raw[i].creationTime * 1000;
    }
    data.push(raw[i]);
  }
  var account: any = null;
  var options: any[] = [];
  for (var j = 0, lgt = data.length; j < lgt; j++) {
    account = data[j];
    options.push({
      label: account.group + " | " + account.firstName + " " + account.lastName,
      value: account.email,
    });
  }
  return options;
};
